export type PlatzhalterWerte = Record<string, string>;

/**
 * Ersetzt {{key}} global. Keys enthalten Punkte (z.B. mieter.vorname) -> im Regex escapen.
 * WICHTIG: Nach der Ersetzung aller bekannten Keys werden ALLE übrig gebliebenen {{...}}-Platzhalter
 * durch '' ersetzt (unbekannte Platzhalter dürfen nicht in echten Mails landen).
 */
export function ersetzePlatzhalter(text: string, werte: PlatzhalterWerte): string {
  let result = text;

  // Replace all known keys
  for (const [key, value] of Object.entries(werte)) {
    // Escape all dots in the key for regex
    const escapedKey = key.replace(/\./g, '\\.');
    const regex = new RegExp(`\\{\\{${escapedKey}\\}\\}`, 'g');
    result = result.replace(regex, () => value);
  }

  // Remove all remaining unknown placeholders {{...}}
  result = result.replace(/\{\{[^}]*\}\}/g, '');

  return result;
}

/**
 * <br>, <br/>, <br /> (case-insensitive) -> '\n'; danach alle übrigen HTML-Tags strippen;
 * mehrfache Leerzeilen auf max. 2 reduzieren; trim.
 */
export function htmlZuText(html: string): string {
  let result = html;

  // Replace <br>, <br/>, <br /> (case-insensitive) with newline
  result = result.replace(/<br\s*\/?>/gi, '\n');

  // Strip all HTML tags
  result = result.replace(/<[^>]*>/g, '');

  // HTML-Entities dekodieren, damit z.B. &nbsp; / &amp; nicht als Text stehenbleiben.
  result = result
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0*39;|&apos;/gi, "'")
    .replace(/&#(\d+);/g, (_m, n) => String.fromCharCode(parseInt(n, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_m, n) => String.fromCharCode(parseInt(n, 16)))
    .replace(/&amp;/gi, '&');

  // Reduce multiple newlines to max 2 (i.e., max 1 blank line)
  result = result.replace(/\n{3,}/g, '\n\n');

  // Trim
  result = result.trim();

  return result;
}
